import {Flex, Text, Box, Link, useToast} from '@chakra-ui/react'
import {Button, Form, Input} from 'antd'
import {CommonColors} from '@utils/CommonStyles'
import {useNavigate} from 'react-router-dom'
import {PATH, STATUS_CODE} from '@utils/Const'
import appRequest from '@apis/app'

const VerifyPassword = ({
  user,
  setIsTypePhone,
  setIsVerifyPassword,
  setIsLoading,
}: {
  user: any
  setIsTypePhone: any
  setIsVerifyPassword: any
  setIsLoading: any
}) => {
  const navigate = useNavigate()
  const toast = useToast()

  const onFinish = async (values: any) => {
    setIsLoading(true)
    const userData = {...user, new_password: values?.password}
    const res = await appRequest.resetPassword(userData)
    if (res?.data?.status === STATUS_CODE.SUCCESS) {
      navigate(PATH.LOGIN, {replace: true})
    } else {
      toast({
        title: res.response?.data?.message || 'Đã có lỗi xảy ra',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
    setIsLoading(false)
  }

  return (
    <Box sx={styles.form} w={{base: '100%', md: '480px'}} mx={'16px'}>
      <Flex flexDirection={'column'}>
        <Text sx={styles.title}>Nhập mật khẩu</Text>
        <Form
          name="basic"
          layout={'vertical'}
          autoComplete="off"
          onFinish={onFinish}>
          <Form.Item
            label="Mật khẩu"
            name="password"
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập mật khẩu!',
              },
            ]}>
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Nhập lại mật khẩu"
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập lại mật khẩu!',
              },
              ({getFieldValue}) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(
                    new Error('Mật khẩu nhập lại không khớp!'),
                  )
                },
              }),
            ]}
            validateTrigger="onChange"
            validateFirst>
            <Input.Password />
          </Form.Item>
          <Form.Item style={{marginTop: '30px'}}>
            <Button htmlType="submit" type="primary" style={styles.button}>
              Tiếp tục
            </Button>
          </Form.Item>
          <Text sx={styles.textRegister}>
            <Link
              color="#1890FF"
              onClick={() => {
                setIsTypePhone(true)
                setIsVerifyPassword(false)
              }}
              ml={'6px'}>
              Thay đổi số điện thoại
            </Link>
          </Text>
        </Form>
      </Flex>
    </Box>
  )
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    backgroundColor: CommonColors.blue1,
  },
  form: {
    flexDirection: 'column',
    backgroundColor: CommonColors.white,
    padding: 8,
    alignItems: 'center',
    borderRadius: '24px',
    justifyContent: 'center',
  },
  button: {
    width: '100%',
    borderRadius: '12px',
    backgroundColor: CommonColors.blue2,
    height: '46px',
  },
  textRegister: {
    fontWeight: 600,
    fontSize: '14px',
    textAlign: 'center',
  },
  title: {
    fontWeight: 600,
    fontSize: '24px',
    textAlign: 'center',
  },
}

export default VerifyPassword
